import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
const TelecallHistory  =  lazy(() => import('../components/TelecallHistory'));
const ProspectHistory  =  lazy(() => import('../components/ProspectHistory'));

const TeleProspect = lazy(() => import('../components/TeleProspect'));

const telecallHistory: RouteObject = {
  path: 'leads',
  element: <TeleProspect />,
  children: [
    {
      path: 'telecall-history',
      element: <TelecallHistory />,
    },
    {
      path: 'prospect',
      element: <ProspectHistory />,
    },
  ],
};

export default telecallHistory;
